import React from 'react';
import { Link } from "react-router-dom";
import DocsVideo from '../reusable_components/DocsVideo';

import student_view_completion_status from '../images/student_view_completion_status.png';

import student_view_search_video from '../videos/student_view_search_video.mov';
import student_view_edit_student_schedule_video from '../videos/student_view_edit_student_schedule_video.mov';

export default function StudentViewDocs({ topic, setTopic, schoolType, embedded = false }) {
	const validTopics = ['student_view_basics'];
	const studentViewTopic = embedded ? 'student_view_basics' : (validTopics.includes(topic) ? topic : 'default');

	const chooseStudentViewTopic = (newTopic) => {
		if (studentViewTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}

		scrollToInstructions('topOfThePage');
	};

	const scrollToInstructions = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	return (
		<div className='documentation-page'>
			<div id='topOfThePage'></div>
			{!embedded &&
				<>
					<p>Use Student View to check each student’s schedule and request fulfillment.</p>
					<p className='documentation-question-heading'>What would you like help with?</p>
					<div className='choose-topic' style={{ margin: '0px 0px 10px 0px' }}>
						<Link className={`choose-topic-btn ${studentViewTopic === 'student_view_basics' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/magnetboard/student_view/${studentViewTopic === 'student_view_basics' ? 'null' : 'student_view_basics'}`} onClick={() => chooseStudentViewTopic('student_view_basics')}>Student view basics</Link>
					</div>
				</>
			}

			{studentViewTopic === 'student_view_basics' &&
			<div className='documentation-container'>
				<h2 className='documentation-page-heading'>Student View</h2>
				<div className='documentation-question-heading'>What would you like help with?</div>
				<div className='documentation-container-instruction-option-container'>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('student_view_search')}>Find specific students</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('student_view_review')}>Student schedule completion status</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('student_view_adjust')}>Open and edit one student schedule</div>
				</div>

				<div id='student_view_search' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Find specific students</div>
					<div className='documentation-step-text'>Use the main search to find students by name. You can also use the filter menu to filter students by grade, special-ed flag, completion status, and courses.</div>
					<DocsVideo src={student_view_search_video}></DocsVideo>
				</div>

				<div id='student_view_review' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Student schedule completion status</div>
					<div className='documentation-step-text'>Each student has a completion status next to their name. Green means 100% complete, yellow means 75% complete or above, and red means anything below 75%.</div>
					<div className='documentation-step-text'>This status is calculated by looking at 2 percentages, the percent of a student's requests that were matched and the percent of a student's day that is full. We use the bigger of these 2 numbers.</div>
					<img className='documentation-screen-image' src={student_view_completion_status} alt='section placement generate schedule screen'/>
					<div className='documentation-step-text'><strong>Why do we calculate it this way?</strong> It's to avoid penalizing the match percentage in the cases of mismatching requests. For example, if a student only submits 2 requests (which isn't enough to fill an entire student day) and we match both of them, then that should count as 100% fulfillment for this student (even though their day isn't fully filled). On the flip side, if a student submits 50 requests (way too many to fit into their schedule) and we fill their entire day, that should also count as 100% fulfillment for this student (even though not all their requests were matched). Our calculation looks at both cases and uses the status that paints the more honest picture of a student's fulfillment.</div>
				</div>

				<div id='student_view_adjust' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Open and edit one student schedule</div>
					<div className='documentation-step-text'>Click <span className='turquoise-text'>Edit Schedule</span> on a student row to open the full student editor, where you can add/remove sections, lock sections, and adjust requests.</div>
					<div className='documentation-step-text'>After making changes, save before leaving the modal so your new placement and conflict updates are retained.</div>
					<div className='documentation-step-text'>Detailed steps are documented here: <Link className='blue-link' to={`/app/${schoolType}/documentation/magnetboard/edit_student_schedule/edit_student_schedule_basics`} target="_blank" rel="noreferrer">Edit Student Schedule docs</Link>.</div>
					<DocsVideo src={student_view_edit_student_schedule_video}></DocsVideo>
				</div>
			</div>
			}
		</div>
	);
}
